import React, { useEffect, useState } from 'react';
import Nav from '../landing/nav';
import './results.css';
import { FiMaximize, FiMinimize } from 'react-icons/fi';

const Results = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    // refreshKey is used to force-refresh the iframe content in the background
    const [refreshKey, setRefreshKey] = useState(Date.now());

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const toggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };

    useEffect(() => {
        // Automatically update the refreshKey every 60 seconds to trigger background refresh
        const refreshInterval = setInterval(() => {
            setRefreshKey(Date.now());
        }, 60000);

        // Override console methods to hide console responses
        const originalConsoleLog = console.log;
        const originalConsoleWarn = console.warn;
        const originalConsoleError = console.error;
        
        console.log = () => {};
        console.warn = () => {};
        console.error = () => {};

        const handleFormSubmission = (event) => {
            if (event.origin === 'https://docs.google.com') {
                window.location.reload();
            }
        };

        window.addEventListener('message', handleFormSubmission);

        // Disable developer tool shortcuts for security
        const disableShortcuts = (e) => {
            if (e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
                (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
                (e.ctrlKey && e.keyCode === 85)) { // Ctrl+U
                e.preventDefault();
            }
        };
        document.addEventListener('keydown', disableShortcuts);

        return () => {
            // Cleanup interval and listeners on component unmount
            clearInterval(refreshInterval);
            window.removeEventListener('message', handleFormSubmission);
            console.log = originalConsoleLog;
            console.warn = originalConsoleWarn;
            console.error = originalConsoleError;
            document.removeEventListener('keydown', disableShortcuts);
        };
    }, []);

    return (
        <div className={`bg-slate-50 min-h-screen ${isFullScreen ? 'fullscreen-mode' : ''}`}>
            <Nav menuOpen={menuOpen} toggleMenu={toggleMenu} />
            
            {/* Floating Exit Button for Fullscreen Mode to ensure visibility */}
            {isFullScreen && (
                <button 
                    onClick={toggleFullScreen} 
                    className="fixed top-6 right-6 z-[3000] bg-red-500 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all flex items-center justify-center"
                    title="Exit Fullscreen"
                >
                    <FiMinimize className="w-6 h-6" />
                </button>
            )}

            <div className="results-container">
                {!isFullScreen && (
                    <header className="results-header">
                        <div className="flex justify-between items-center">
                            <div>
                                <h1 className="results-title">Election Results</h1>
                                <p className="results-subtitle">The results below refresh automatically every minute.</p>
                            </div>
                            <button onClick={toggleFullScreen} className="fullscreen-button">
                                <FiMaximize className="w-6 h-6" />
                            </button>
                        </div>
                    </header>
                )}

                <div className={`results-iframe-container ${isFullScreen ? 'fullscreen' : ''}`}>
                    <iframe
                        id="results-iframe"
                        // Appending the refreshKey as a timestamp ensures the browser fetches fresh data
                        src={`https://docs.google.com/spreadsheets/d/e/2PACX-1vRvlQUDh8GWVBdandGHXHY_wJW1jyDakXKlC3ECk8tNOFZBChx_Y-ctujH93EniPu7dnymwsBWx25pK/pubhtml?gid=1973135710&single=true&t=${refreshKey}`}
                        title="Election Return Results"
                        className="results-iframe"
                        sandbox="allow-same-origin allow-scripts allow-forms"
                    >
                        Loading…
                    </iframe>
                </div>
            </div>
        </div>
    );
};

export default Results;